module.exports = __webpack_public_path__ + "img/TISCO.400edd5a.png";